import { render, staticRenderFns } from "./LegalDocumentsListComponent.vue?vue&type=template&id=5d1a5fea&"
import script from "./LegalDocumentsListComponent.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentsListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports